import React from 'react';

import { createIcon } from '../createIcon';

function SvgClear(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path d="M2 2h12v12H2z" />
        <path
          d="M13.734 2.275a.906.906 0 00-1.283 0L8 6.717l-4.45-4.45a.906.906 0 10-1.284 1.282L6.716 8l-4.45 4.45a.906.906 0 101.283 1.284L8 9.284l4.45 4.45a.906.906 0 101.284-1.283L9.284 8l4.45-4.45a.912.912 0 000-1.275z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export const ClearFilledIcon = createIcon(SvgClear, 'ClearFilledIcon');
